import { ClusterDisplayStatus, ClusterStatus } from '@cast/types';

type ClusterWithNotFoundStatus = {
  displayStatus?: ClusterDisplayStatus;
  status?: ClusterDisplayStatus | ClusterStatus;
};

const isNotFoundCluster = (cluster: ClusterWithNotFoundStatus) =>
  cluster.displayStatus === ClusterDisplayStatus.NOT_FOUND ||
  cluster.status === ClusterDisplayStatus.NOT_FOUND;

export const partitionNotFoundClusters = <T extends ClusterWithNotFoundStatus>(
  clusters: T[]
) => {
  const activeClusters: T[] = [];
  const notFoundClusters: T[] = [];

  for (const cluster of clusters) {
    if (isNotFoundCluster(cluster)) {
      notFoundClusters.push(cluster);
    } else {
      activeClusters.push(cluster);
    }
  }

  return { activeClusters, notFoundClusters };
};
